import LegalLayout from "@/components/LegalLayout";

const Block = ({ heading, children }) => (
  <div>
    <h2 className="font-display uppercase tracking-wide text-xl text-white mb-3">{heading}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz&shy;erklärung">
      <p>
        Der Schutz deiner persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten deine
        Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021). In dieser
        Datenschutzerklärung informieren wir dich über die wichtigsten Aspekte der Datenverarbeitung
        im Rahmen unserer Website.
      </p>

      <Block heading="Verantwortlicher">
        <p className="text-white font-semibold">VPT Operations GmbH</p>
        <p>Römerweg 1c, 8434 Tillmitsch, Österreich</p>
        <p>
          E-Mail:{" "}
          <a href="mailto:tuningfiles@vmaxx.at" className="text-primary hover:underline">
            tuningfiles@vmaxx.at
          </a>
        </p>
      </Block>

      <Block heading="Kontaktaufnahme &amp; Anfrageformular">
        <p>
          Wenn du uns über das Formular auf der Website oder per E-Mail bzw. WhatsApp kontaktierst,
          werden deine angegebenen Daten (Name, E-Mail-Adresse, Fahrzeugtyp, Nachricht) zwecks
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
        </p>
        <p>
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. lit. f
          (berechtigtes Interesse an der Beantwortung von Anfragen). Diese Daten geben wir nicht ohne
          deine Einwilligung weiter und löschen sie, sobald die Bearbeitung abgeschlossen ist und
          keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </p>
      </Block>

      <Block heading="Cookies &amp; Einwilligung">
        <p>
          Unsere Website verwendet technisch notwendige Cookies, die für den Betrieb erforderlich
          sind. Optionale Analyse-Cookies setzen wir nur mit deiner ausdrücklichen Einwilligung
          (Cookie-Banner) auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO ein. Deine Einwilligung kannst
          du jederzeit mit Wirkung für die Zukunft widerrufen, indem du die gespeicherte Auswahl in
          deinem Browser löschst.
        </p>
      </Block>

      <Block heading="Webanalyse">
        <p>
          Zur Verbesserung unseres Angebots verwenden wir eine datenschutzfreundliche Analyse-Lösung.
          Eine Auswertung erfolgt nur nach deiner Einwilligung. Es werden keine Daten ohne deine
          Zustimmung an Dritte zu Werbezwecken weitergegeben.
        </p>
      </Block>

      <Block heading="Fahrzeug-Konfigurator (Drittanbieter)">
        <p>
          Zur Darstellung des Fahrzeug-Konfigurators binden wir einen externen Dienst per iframe ein.
          Beim Laden können technische Verbindungsdaten (z. B. IP-Adresse) an den Anbieter übertragen
          werden. Wir haben auf diese Verarbeitung keinen Einfluss.
        </p>
      </Block>

      <Block heading="Server-Logfiles">
        <p>
          Der Provider erhebt und speichert automatisch Informationen in Server-Logfiles, die dein
          Browser übermittelt (Browsertyp, Betriebssystem, Referrer-URL, Uhrzeit, IP-Adresse). Diese
          Daten sind nicht bestimmten Personen zuordenbar und dienen der technischen Sicherheit.
        </p>
      </Block>

      <Block heading="Deine Rechte">
        <p>
          Dir stehen die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertrag&shy;barkeit,
          Widerruf und Widerspruch zu. Wenn du glaubst, dass die Verarbeitung deiner Daten gegen das
          Datenschutzrecht verstößt, kannst du dich bei der Österreichischen Datenschutzbehörde
          (www.dsb.gv.at) beschweren.
        </p>
        <p>
          Zur Wahrnehmung deiner Rechte kontaktiere uns unter{" "}
          <a href="mailto:tuningfiles@vmaxx.at" className="text-primary hover:underline">
            tuningfiles@vmaxx.at
          </a>
          .
        </p>
      </Block>
    </LegalLayout>
  );
}
